export default "__VITE_ASSET__a$ZD0bCs__"